import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidMultisyllabicKeyboardChooseRule } from '../../../../mechanics/rid-multisyllabic-keyboard-choose-rule/rid-multisyllabic-keyboard-choose-rule';

@Component({
  selector: 'app-syllabic-keyboard-plus-choose-rule-page',
  imports: [RidMultisyllabicKeyboardChooseRule],
  templateUrl: './syllabic-keyboard-plus-choose-rule-page.html',
})
export class SyllabicKeyboardPlusChooseRulePage {
  protected readonly $router = inject(Router);
}
